import { Box, Flex, Icon, Text, useColorModeValue } from '@chakra-ui/react';
import i18next from 'i18next';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiExitFullscreen, BiFullscreen } from 'react-icons/bi';
import { FaScroll } from 'react-icons/fa';
import { IoIosArrowBack, IoMdClose } from 'react-icons/io';
import { RiArrowDropRightLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';

import ToggleFavorite from '../../../components/Favorite/ToggleFavorite';
import LoadingLine from '../../../components/Loading/LoadingLine';
import useCheckLogin from '../../../hook/useCheckLogin';
import UseGetGameBoxBackPathV2 from '../../../hook/useGetGameBoxBackPath_v2';
import useGetNowGame from '../../../hook/useGetNowGame';
import {
  closeFullScreen,
  openFullScreen,
  storeGameConfig
} from '../../../redux/action/game/gameAction';
import { openGameDescriptionPop } from '../../../redux/action/member/memberAction';
import { languageTransfer } from '../../../utils/languageTransfer';
import useGameIsHasDescription from '../gameDescription/gameIsHasDescription';
import PCToolTab from './PCToolTab';
import useGames from '../useGames';

const GameBoxHeader = () => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);

  const nowGameConfig = useGetNowGame();

  const dispatch = useDispatch();

  const getPrevPath = UseGetGameBoxBackPathV2();

  const [hiddenHeader, setHiddenHeader] = useState(false);

  const { handleExitGame } = useGames();

  const { to } = useParams();

  useEffect(() => {
    dispatch(storeGameConfig(nowGameConfig));
  }, [nowGameConfig]);

  const isOpenFullScreen = useSelector((state) => state.isOpenFullScreen);

  const navigate = useNavigate();

  const textColor = useColorModeValue('light.100', 'light.100');

  const gameConfig = useSelector((state) => state.isGameConfig);

  const { game_platform, game_subtype, SubPlatformEnum } = gameConfig || {};

  const gameIsHasDescription = useGameIsHasDescription({ game_platform });

  const gameName = useMemo(() => {
    return gameConfig?.[
      `gameName${languageTransfer({ lang: i18next.language })}`
    ];
  }, [gameConfig, i18next.language]);

  const { isMachineUser } = useCheckLogin();

  useEffect(() => {
    if (isOpenFullScreen) {
      setHiddenHeader(true);
    } else {
      setHiddenHeader(false);
    }
  }, [isOpenFullScreen]);

  return (
    <>
      <PCToolTab
        setHiddenHeader={setHiddenHeader}
        hiddenHeader={hiddenHeader}
      />

      {!hiddenHeader && (
        <Flex
          w="100%"
          alignItems={`center`}
          justifyContent={`space-between`}
          py="8px"
          px="20px"
          h="52px"
          minH="52px"
          bgImage={`linear(to-b,#AD8D70,#E3D4BA,#7C6150)`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100%100%"
        >
          {' '}
          <Box as="section" fontWeight={`semibold`} color="brand.500">
            <Box
              as="section"
              mb="0"
              fontSize="xl"
              display={`flex`}
              alignItems={`center`}
            >
              {isOpenFullScreen && (
                <Box
                  minW={'48px'}
                  h={'52px'}
                  rounded={'5px'}
                  gap={'10px'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  cursor="pointer"
                  className={`!flex`}
                  color="white"
                  onClick={() => {
                    setHiddenHeader(true);
                  }}
                >
                  {' '}
                  <IoIosArrowBack className="text-2xl" />
                </Box>
              )}
              <Text as="span" color="white">
                {SubPlatformEnum || game_platform} -
              </Text>
              <Text as="span" color="white">
                {gameName}
              </Text>
            </Box>
          </Box>
          <Flex
            alignItems={`center`}
            gap="10px"
            fontSize="3xl"
            color="light.600"
            position="relative"
          >
            {!isMachineUser && ( //機台使用者不顯示
              <ToggleFavorite />
            )}
            {isOpenFullScreen ? (
              <Icon
                onClick={() => {
                  dispatch(closeFullScreen());
                }}
                cursor="pointer"
                as={BiExitFullscreen}
                fontSize="2xl"
                color={textColor}
              />
            ) : (
              <Icon
                onClick={() => {
                  dispatch(openFullScreen());
                }}
                cursor="pointer"
                as={BiFullscreen}
                fontSize="2xl"
                color={textColor}
              />
            )}
            {gameIsHasDescription && (
              <Icon
                onClick={() => {
                  dispatch(
                    openGameDescriptionPop({
                      game: game_platform
                    })
                  );
                }}
                cursor="pointer"
                as={FaScroll}
                fontSize="2xl"
                color={textColor}
              />
            )}
            <Icon
              onClick={() => {
                // dispatch(
                //   toggleBGM({
                //     enabled: true,
                //     song: "back2",
                //     musicVolume: 0.2,
                //   })
                // );
                // navigate(
                //   `/${getPrevPath}/category/${SubPlatformEnum || to}/AllGames`,
                // );
                handleExitGame();
              }}
              cursor="pointer"
              as={IoMdClose}
              fontSize="2xl"
              color={textColor}
            />
          </Flex>
        </Flex>
      )}
    </>
  );
};

export default GameBoxHeader;
